import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/contact/page.tsx");
